import React from 'react'
import Home from '../view/home/Home'
import Skill from '../view/home/Skill'
import {Route,Switch} from 'react-router-dom'
import About from '../view/About'
import Start from '../view/Start'
import MyContact from '../view/MyContact'
import MyPorto from '../view/MyPorto'

const Router = () => {
    return (
        <div>
            <Switch>
                <Route path="/" exact component={Start} />
                <Route path="/home" exact component={Home} />
                <Route path="/about" exact component={About}/>
                <Route path="/skilL" exact component={Skill}/>
                <Route path="/porto" exact component={MyPorto}/>
                <Route path="/contact" exact component={MyContact}/>
            {/* <Route path="/detail/:id" exact component={Detail}/> */}
            {/* <Route component={NotFound}/> */}
            </Switch>
        </div>
    )
}

export default Router
